import 'react';
import { StatusSuccess, StatusAlert, InProgress } from './styles.js';
import { TimelineStepStatus } from './types.js';
import { jsx } from '@emotion/react/jsx-runtime';

function StatusIcon({
  status
}) {
  if (status === TimelineStepStatus.Success) {
    return jsx(StatusSuccess, {
      size: "md",
      role: "presentation"
    });
  } else if (status === TimelineStepStatus.Alert) {
    return jsx(StatusAlert, {
      size: "md",
      role: "presentation"
    });
  }
  return jsx(InProgress, {
    role: "presentation"
  });
}

export { StatusIcon as default };
